import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { addErrorMessage, removeErrorMessage } from '../../../redux/slices/appStateSlice';
import config from '../../../temp/config';
import { updateBankAddress, updateBankName } from '../../../redux/slices/quoteDataSlice';
import { pushEvent, resolveEvent, pushServiceDownError } from '../../../utils/analytics/datalayer';

const BankDetails = ({
  rendering,
  fields,
  hasError,
  defaultValue,
  errorMessages,
  quote,
  showBankDetails,
}) => {
  const dispatch = useDispatch();
  const raiseDatalayerEvent = () => {
    const event = resolveEvent(fields.datalayerEvent?.value, quote);
    pushEvent(event);
  };

  const checkBankDetails = async () => {
    await fetch(config?.endpoints?.bankValidation, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sortCode: defaultValue.sortCode.replace(/-/g, ''),
        accountNumber: defaultValue.accountNumber,
        requestHeaders: {
          updatedBySystem: config?.referenceData?.systemEntityNumber,
          updatedByUser: config?.referenceData?.systemEntityNumber,
        },
      }),
    })
      .then(async response => {
        if (response.ok) {
          const data = await response.json();

          if (data.validationResult) {
            const addressObject = {
              addressline1: data.addressline1 || data.postCode,
              addressline2: data.addressline2 || data.postCode,
              addressline3: data.addressline3 || data.postCode,
              addressline4: data.town || data.addressLine4 || data.postCode,
              town: data.town || data.postCode,
              county: data.county || data.postCode,
              postCode: data.postCode,
            };
            raiseDatalayerEvent();
            dispatch(updateBankName(data.bankName));
            dispatch(updateBankAddress(addressObject));
            dispatch(removeErrorMessage(`${rendering.uid}-api`));
          } else {
            dispatch(
              addErrorMessage({
                uid: `${rendering.uid}-api`,
                message: fields.lookUpFailed?.value,
              })
            );
            return false;
          }
        } else {
          await pushServiceDownError(config?.endpoints?.bankValidation, response);
          dispatch(
            addErrorMessage({
              uid: `${rendering.uid}-api`,
              message: fields.lookUpFailed?.value,
            })
          );
          return false;
        }
      })
      .catch(function (err) {
        pushServiceDownError(config?.endpoints?.bankValidation, null, err);
        dispatch(
          addErrorMessage({
            uid: `${rendering.uid}-api`,
            message: fields.techError?.value,
          })
        );
        return false;
      });
  };

  useEffect(() => {
    if (
      hasError &&
      errorMessages?.length > 1 &&
      typeof errorMessages.find(p => p.uid === `${rendering.uid}-api`) !== 'undefined'
    ) {
      dispatch(removeErrorMessage(`${rendering.uid}-api`));
    }
  });
  useEffect(() => {
    const directdebitbranchsortcode = document.getElementById('direct-debit-branch-sortcode');
    directdebitbranchsortcode?.addEventListener('change', function (e) {
      if (!e.target.value.trim().length) {
        dispatch(removeErrorMessage(`${rendering.uid}-api`));
      }
    });
    const directdebitaccountnumber = document.getElementById('direct-debit-account-number');
    directdebitaccountnumber?.addEventListener('change', function (e) {
      if (!e.target.value.trim().length) {
        dispatch(removeErrorMessage(`${rendering.uid}-api`));
      }
    });
  }, []);

  useEffect(() => {
    if (
      showBankDetails &&
      (!hasError ||
        (hasError &&
          errorMessages?.length === 1 &&
          errorMessages[0]?.uid === `${rendering.uid}-api`)) &&
      defaultValue.accountHolder &&
      defaultValue.accountNumber &&
      defaultValue.sortCode
    ) {
      checkBankDetails();
    }
  }, [
    showBankDetails,
    defaultValue.sortCode,
    defaultValue.accountNumber,
    defaultValue.accountHolder,
  ]);

  return <></>;
};

const mapStateToProps = (state, props) => {
  const defaultValues = {
    accountHolder: state.quoteData.prospectDetails.bankDetails.accountHolder,
    sortCode: state.quoteData.prospectDetails.bankDetails.branchSortCode,
    accountNumber: state.quoteData.prospectDetails.bankDetails.accountNumber,
  };
  const displayErrors = state.appState.displayErrors;
  return {
    ...props,
    hasError: state.appState?.hasError,
    defaultValue: defaultValues,
    displayErrors,
    errorMessages: state.appState?.errorMessages,
    quote: state.quoteData.selectedQuote,
    showBankDetails:
      state.quoteData.prospectDetails.bankDetails.isAccountHolder &&
      state.quoteData.prospectDetails.bankDetails.isOnlySignatory,
  };
};

export default connect(mapStateToProps)(BankDetails);
